import { Attr, BelongsTo, HasMany, HasOne, Model } from "spraypaint";

import { type SpikeType } from "shared/constants";
import type { StreamOptionsFilters } from "shared/helpers/StreamFilters";
import { ApplicationRecord } from "shared/services/spraypaint";
import type {
  Nullable,
  StreamNotificationFilter,
  StreamNotificationSource,
} from "shared/types";
import type { SocialMentionType } from "shared/types/mentions";

import type Recipient from "./Recipient";
import type Stream from "./Stream";
import type StreamNotificationSpecification from "./StreamNotificationSpecification";
import type User from "./User";

@Model()
class StreamNotification extends ApplicationRecord {
  static jsonapiType = "stream_notifications";

  @Attr({ persist: false }) archivedAt: string;

  @Attr() email: boolean;

  @Attr() enabled: boolean;

  @Attr() filters: Nullable<StreamNotificationFilter[]>;

  @Attr() filterSetId: Nullable<number>;

  @Attr() includeAiSummary: boolean;

  @Attr() magazineContent: boolean;

  @Attr() microsoftTeams: boolean;

  @Attr({ persist: false }) microsoftTeamsRecipients: string;

  @Attr() mobile: boolean;

  @Attr() onlineContent: boolean;

  @Attr() options: Nullable<StreamOptionsFilters>;

  @Attr() podcastContent: boolean;

  @Attr() printContent: boolean;

  @Attr() radioContent: boolean;

  @HasMany() recipients: Recipient[];

  @Attr() riskScore: number;

  @Attr() selectedSocialContent: SocialMentionType[];

  @Attr() slack: boolean;

  @Attr() slackChannelName: string;

  @Attr() slackRecipients: string;

  @Attr() socialContent: boolean;

  @Attr() sources: Nullable<StreamNotificationSource[]>;

  @Attr() spikeType: SpikeType;

  @BelongsTo() stream: Stream;

  @Attr() streamId: number;

  @HasOne() streamNotificationSpecification: StreamNotificationSpecification;

  @Attr() threshold: number;

  @Attr() tvContent: boolean;

  @Attr() type: string;

  @BelongsTo() user: User;

  @Attr() userId: Nullable<number>;
}

export default StreamNotification;
